import React from "react";
import TextField from "@mui/material/TextField";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider, MobileDatePicker } from "@mui/x-date-pickers";
import { Timestamp } from "firebase/firestore";
import dayjs from "dayjs";

export default function DatePickerV2ComponentNoTitleMobile(props) {
  const handleChange = (date) => {
    const timestamp = Timestamp.fromMillis(date.valueOf());
    props.onChange(timestamp);
  };

  const dateObject =
    props.value && typeof props.value.toMillis === "function"
      ? dayjs(new Date(props.value.toMillis()))
      : dayjs(props.value);

  return (
    <div className="input-label-container-newdesign-mobile">
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <MobileDatePicker
          value={dateObject}
          onChange={handleChange}
          format="DD/MM/YYYY"
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              error={false}
              InputProps={{
                sx: {
                  height: "30px", // Adjust height
                  fontSize: "12px", // Adjust font size
                  padding: "2px 4px", // Adjust padding for height
                },
              }}
              InputLabelProps={{
                sx: {
                  fontSize: "12px", // Adjust font size of the label if necessary
                },
              }}
              sx={{
                width: "150px", // Adjust width
                "& .MuiOutlinedInput-root": {
                  height: "30px", // Adjust height of the input
                },
                "& .MuiOutlinedInput-input": {
                  padding: "8px 14px", // Adjust padding for height
                  fontSize: "12px", // Adjust font size
                },
                "& .MuiSvgIcon-root": {
                  // fontSize: "10px", // Adjust size of the icon
                },
              }}
            />
          )}
        />
      </LocalizationProvider>
    </div>
  );
}
